import type { Username } from '@isoapp/common/platform/types/user/username'

import type { Extension } from '#@/platform/networking/client/types/extension'

export function admin(_impersonate?: Username): Extension {
  return {
    tag: 'admin',
    apply() {
      throw new Error('Admin middleware has not been implemented for this platform')
    },
  }
}
